import intl from 'react-intl-universal';
import { getTargetCookie, setCookie } from '@src/utils/cookie';

const { history } = window;

export const CURRENT_LOCALE = 'interview-questionnaire-lang';
export enum LocaleValue {
    en = 'en-US',
    zh = 'zh-CN'
}
const locales = {
    [LocaleValue.en]: require('./language/en-US.ts').default,
    [LocaleValue.zh]: require('./language/zh-CN.ts').default
};

export const getCurrentLocale = (): LocaleValue => {
    const navigatorLocale = navigator.language.toLowerCase().includes('zh')
        ? LocaleValue.zh
        : LocaleValue.en;
    const currentLocale = (getTargetCookie(CURRENT_LOCALE) as LocaleValue) || navigatorLocale;
    return currentLocale;
};

export const isEn = () => {
    return getCurrentLocale() === LocaleValue.en;
};

export const registerLanguage = async () => {
    await intl.init({ currentLocale: getCurrentLocale(), locales });
};

export const changeLanguage = (lang: LocaleValue, reloadUrl?: string) => {
    setCookie(CURRENT_LOCALE, lang);
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    } else {
        window.onunload = () => window.scrollTo(0, 0);
    }
    if (!reloadUrl) {
        window.location.reload();
    } else {
        window.location.href = reloadUrl;
    }
};
